import { ParameterDataType } from "./ParameterDataType";
import { TypeMember } from "./TypeMember";

export class DataType
{
  protected _name:string;
  get name(){ return this._name; }  
  protected _members:TypeMember[];
  get members(){ return this._members }

  constructor( name:string )
  {
    this._name = name;
  }

  setMembers( members:TypeMember[] )
  {
    this._members = [].concat( members );

    return this;
  }

  
}